'use strict'
import { request } from '../../plugins/http'

export default async (id) => {
    return await request.delete('/setor?id=' + id)
}